import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiResponse } from '@card-software/nexus-utilities';
import { LocationNode } from '@app/models/inventory/location';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/location';

  public getAll() {
    return this.httpClient.get<ApiResponse<LocationNode[]>>(this.baseUrl + '/all');
  }

  public getByCode(code: string) {
    return this.httpClient.get<ApiResponse<LocationNode>>(`${this.baseUrl}/code/${encodeURIComponent(code)}`);
  }

  /**
   * @param detailed when true, the API also returns fullName/pathNames (the full location hierarchy).
   */
  public batchGetByCodes(codes: string[], detailed = false) {
    return this.httpClient.post<ApiResponse<LocationNode[]>>(`${this.baseUrl}/code/batch?detailed=${detailed}`, codes);
  }
}
